import React from 'react';
import './Obituary.css';
import '../resources/text/obituary.js';
class Obituary extends React.Component {
    constructor(props){
        super(props);
        this.sate = {
            ObituaryText: "Testing the obituary"
        }

    }
    render(){
        return(
            <div>
                <p>
                    This is a test Obituary
                </p>
                <p className='Obituary-text'>
                   Born April 11,1947 in Brooklyn, NY, Jack was a proud veteran of the United States Airforce. He returned to the States and lived in New York, Ohio, Illinois and Florida  He was living in Circleville, Ohio until he was diagnosed with Glioblastoma in May of 2019.  He fought courageously until he died in his loving wife’s arms on May 29th 2020 while listening to music. His last wish to her is that they will love each other forever.

                   He leaves behind his wife of 32 years, Coletta Braun (nee Schmidt ), and  6 children – “MEME" Watrobski (Matt)ary Ellen Wotroboski (Matt); Julie Cronin (Tom); John T Braun Jr. (Sarah);Robert Braun; Donald Bacharowki (Diana Kuiper); Kathryn Bacharowski (Matt McGraw).  He was blessed with many beautiful grandchildren. He was Papaw to Granddaughter Violet and Grandson John. He leaves his brother Charles (the late Nancy), and his sisters Marie Renkel (Gene) and Janet Lundy of Pensacola, Fl. He loved his nieces and nephews, in-laws, and out-laws, and he especially enjoyed beating all of them at card games that lasted late into the night.

                   Jack inspired laughter and hope wherever he went. He had a way of making the company of others seem easy - sometimes as the host and life of the party - others as a loved one who we could count on privately to see light at the end of the occasional tunnel. His energy and love deeply touched family, friends, neighbors, and colleagues; his generosity touched all in his community; and he would tell you that he hasn’t lost a game of bridge since 1945. His favorite singer was NOT Britney Spears.  He was a true Gentleman and had pretty blue eyes.

                   Jack will be laid to rest at Ohio Western Reserve National Cemetery. On June 12, 2020  A Military Burial Ceremony will be scheduled for a later date pending the release of restrictions from the COVID-19 virus. The family requests donations to a charitable organization or to:

                   Wounded Warriors Project: Donor Care Center P.O. Box 75853 Topeka, KS 66675
                   Blast Glioblastoma Foundation 2383 S Main St Suite D-106 Akron, OH 44319

                   Make donations in Honor of Jack Braun  224 S Court St  # 281  Circleville, OH 43113.

                   A website has been created at johntbraun.com and will be updated often. If you wish to share photos, videos, stories, etc. please email them to jackbraun@gmail.com.  A link to his FB page is included on the website.
                </p>
            </div>
        );
    }
}
export default Obituary;